import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { programService } from 'src/config/rootService';
import { Markdown } from 'src/modules/newPrograms/components/Markdown';
import { Page, PageProps } from 'src/modules/newPrograms/components/Page';
import { ProgramPageFragment } from 'src/modules/newPrograms/documents/getProgram.generated';
import { Input } from 'src/shared/components/Input';

interface TextInputPageProps extends PageProps {
    page: ProgramPageFragment;
}

export const TextInputPage: FC<TextInputPageProps> = ({ page, onNavigatePrev, onNavigateNext }) => {
    const { t } = useTranslation();

    const pageAnswers = page.parsedAnswerOptions;

    return (
        <Page onNavigatePrev={onNavigatePrev} onNavigateNext={onNavigateNext}>
            <Markdown
                textHorizontalAlignment={page.contentHorizontalAlignment}
                text={page.content ?? ''}
            />
            <Input
                type="textarea"
                value={pageAnswers?.[0]?.customOptionValue ?? ''}
                onChange={data => {
                    programService.selectPageAnswer(page.id, 0, true, String(data));
                }}
                placeholder={t('programs:components.program_page.placeholder.text_input')}
                fieldId="answer"
            />
        </Page>
    );
};
